<template>
  <div class="auto-complete-address">
    <next-transition :visible="auto">
    <input-label :text="label" />
    <input-address
        v-model="autoComplete"
        :placeholder=" $t('address.autocomplete.placeholder')"
        :address.sync="addressSync" />
    </next-transition>
    <next-transition :visible="displayDecomposedForm"  >
      <div class="auto-complete-address__decomposed">
        <input-label :text="subtitle"/>
        <el-row :gutter="25">
          <el-col :xs="24" :sm="12" :md="24" :lg="12"
                  class="auto-complete-address__decomposed__item
                  auto-complete-address__decomposed__item__street"
                  v-if="displayStreet">
            <input-with-label
              v-model="streetSync"
              :label="$t('address.address.street.label')"
              :placeholder="$t('address.address.street.label')"/>
          </el-col>
          <el-col :xs="24" :sm="5" :md="10" :lg="5"
                  class="auto-complete-address__decomposed__item
                  auto-complete-address__decomposed__item__cp">
            <input-with-label
                data-cy="address-postal"
              v-model="postalSync"
              :label="$t('address.address.postal.label')"
              :placeholder="$t('address.address.postal.label')"/>
          </el-col>
          <el-col :xs="24" :sm="7" :md="14" :lg="7"
                  class="auto-complete-address__decomposed__item
                  auto-complete-address__decomposed__item__city">
            <input-with-label
                data-cy="address-city"
              v-model="citySync"
              :label="$t('address.address.city.label')"
              :placeholder="$t('address.address.city.label')"/>
          </el-col>
        </el-row>
        <el-row class="auto-complete-address__decomposed__errors"
                v-for="error in errors" :key="error">
            {{ error }}
        </el-row>
      </div>
    </next-transition>
  </div>
</template>

<script>
import InputAddress from './InputAddress.vue';
import InputLabel from '@/components/utils/InputLabel.vue';
import InputWithLabel from './InputWithLabel.vue';
import NextTransition from '@/components/utils/NextTransition.vue';

export default {
  name: 'AutoCompleteAddress',
  components: {
    NextTransition, InputWithLabel, InputAddress, InputLabel,
  },
  model: {
    prop: 'address',
    event: 'change',
  },
  props: {
    address: {
      type: Object,
      default() {
        return {
          city: '',
          country: null,
          postal: '',
          street: '',
        };
      },
    },
    label: {
      type: String,
      required: true,
    },
    secondaryLabel: {
      type: String,
      required: true,
    },
    auto: {
      type: Boolean,
      default: false,
    },
    displayStreet: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      autoComplete: '',
      errors: [],
    };
  },
  computed: {
    addressSync: {
      get() {
        return this.address;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
    citySync: {
      get() {
        return this.address.city;
      },
      set(value) {
        this.$emit('update:city', value);
      },
    },
    postalSync: {
      get() {
        return this.address.postal;
      },
      set(value) {
        this.$emit('update:postal', value);
      },
    },
    streetSync: {
      get() {
        return this.address.street;
      },
      set(value) {
        this.$emit('update:street', value);
      },
    },
    displayDecomposedForm() {
      return !this.auto;
    },
    subtitle() {
      return this.auto && this.streetSync ? this.$t('address.address.label')
        : this.secondaryLabel;
    },
  },
  methods: {
    formatAddress() {
      let res = '';
      const addressKeys = ['street', 'postal', 'city'];
      for (const key of addressKeys) {
        if (this.address[key]) res += `${this.address[key]}, `;
      }
      res = res.trim();
      res = res.slice(0, res.length - 1);
      return res;
    },
    addError(error) {
      if (this.errors.findIndex(e => e === error) === -1) this.errors.push(error);
    },
    removeError(error) {
      const index = this.errors.findIndex(e => e === error);
      if (index !== -1) this.errors.splice(index, 1);
    },
  },
  mounted() {
    if (this.address.street) this.autoComplete = `${this.address.street}, ${this.address.postal}, ${this.address.city}`;
  },
  watch: {
    citySync() {
      this.autoComplete = this.formatAddress();
    },
    postalSync(value) {
      this.autoComplete = this.formatAddress();
      if (value) {
        if (value.match(/^(?:[0-8]\d|9[0-8])\d{3}$/)) this.removeError(this.$t('errors.address.postal_code'));
        else this.addError(this.$t('errors.address.postal_code'));
      }
    },
    streetSync() {
      this.autoComplete = this.formatAddress();
    },
  },
};
</script>

<style scoped lang="scss">
  .auto-complete-address{
    &__decomposed{
      &__item {
        margin-top: 8px;
      }
      &__errors{
        margin-top: 8px;
        color: $--color-danger
      }
    }
  }
</style>
